import _ from "lodash";
import { Avatar } from "@toddle-edu/ds-web";
import React from "react";
import classes from "./DualProfile.scss";
import { AVATAR_COLORS } from "Constants/colorConstants";
import { hashString } from "Utils";

const style = {
  profileContainer: {
    position: "relative",
    zIndex: 1,
  },
};

const BLANK_OBJECT = {};
export const DualProfile = props => {
  const {
    user1 = {},
    user2 = {},
    showNewDesign = false,
    cascadeProfileStyle,
    shape = "circle",
  } = props;

  return (
    <div
      className={classes.cascadedProfileContainer}
      style={showNewDesign ? style.profileContainer : BLANK_OBJECT}
    >
      {user1 && !_.isEmpty(user1) && (
        <Avatar
          dsVersion="2.0"
          name={_.upperCase(user1?.value)}
          src={user1?.imageUrl}
          shade={"light"}
          color={AVATAR_COLORS[hashString(user1?.id) % AVATAR_COLORS.length]}
          size={"medium"}
          shape={shape}
        />
      )}

      {user2 && !_.isEmpty(user2) && (
        <div
          className={classes.cascadedProfile}
          style={{
            ...(showNewDesign ? { position: "relative", zIndex: -1 } : {}),
            ...cascadeProfileStyle,
          }}
        >
          <Avatar
            dsVersion="2.0"
            name={_.upperCase(user2?.value)}
            src={user2?.imageUrl}
            shade={"light"}
            color={AVATAR_COLORS[hashString(user2?.id) % AVATAR_COLORS.length]}
            size={"medium"}
            shape={shape}
          />
        </div>
      )}
    </div>
  );
};
